const translations = {
  // Nav
  nav_home: "Home",
  nav_about: "About",
  nav_plans: "Pension Plans",
  nav_calculator: "Calculator",
  nav_benefits: "Benefits",
  nav_contact: "Contact",
  nav_open_account: "Open Account",

  // Hero
  hero_badge: "Norwegian State Pension Fund",
  hero_title_1: "Your financial",
  hero_title_2: "future",
  hero_title_3: "starts today",
  hero_desc: "Investment contracts with guaranteed returns from 3% to 198%. Stable pension payments and dividend income every month.",
  hero_cta_calc: "Calculate Pension",
  hero_cta_learn: "Learn More",
  hero_stat_assets: "Assets under management",
  hero_stat_companies: "Companies in portfolio",
  hero_stat_countries: "Countries of investment",
  hero_stat_years: "Years of experience",

  // About
  about_badge: "About the Fund",
  about_title_1: "The world's largest sovereign",
  about_title_2: "pension fund",
  about_desc1: "Government Pension Fund Global (GPFG) is Norway's state pension fund, founded in 1990. The fund manages assets worth more than €1.4 trillion, making it the world's largest sovereign wealth fund.",
  about_desc2: "The fund invests in shares of more than 9,000 companies in 70 countries, ensuring maximum diversification and capital protection. Every investment contract is guaranteed by the Norwegian state.",
  about_feat1: "Moody's AAA Rating",
  about_feat2: "Norwegian Ministry of Finance",
  about_feat3: "Investments in 70 countries",
  about_feat4: "100% state guarantee",
  about_cta: "Choose a Plan",
  about_years: "years of reliable work",

  // Plans
  plans_badge: "Investment Contracts",
  plans_title: "Choose your pension plan",
  plans_desc: "Three levels of investment contracts with guaranteed returns. The higher the amount — the greater your dividend income.",
  plans_badge1: "Basic Level",
  plans_badge2: "Popular Choice",
  plans_badge3: "Maximum Benefit",
  plans_tier1: "Starter",
  plans_tier2: "Optimal",
  plans_tier3: "Premium",
  plans_contract: "investment contract",
  plans_per_month: "per month",
  plans_monthly: "Monthly:",
  plans_sign: "Sign Contract",
  plans_feat1_1: "3–5% monthly return",
  plans_feat1_2: "Monthly payments",
  plans_feat1_3: "State guarantee",
  plans_feat1_4: "Investor online account",
  plans_feat1_5: "Free consultation",
  plans_feat2_1: "Up to 103% monthly return",
  plans_feat2_2: "Enhanced dividends",
  plans_feat2_3: "Priority service",
  plans_feat2_4: "Personal manager",
  plans_feat2_5: "Profit reinvestment",
  plans_feat3_1: "157–198% monthly return",
  plans_feat3_2: "VIP service",
  plans_feat3_3: "Personal manager",
  plans_feat3_4: "Quarterly bonuses",
  plans_feat3_5: "Exclusive investments",
  plans_disclaimer: "* Returns are based on historical fund data. Investments are protected by Norway's state guarantee.",

  // Calculator
  calc_badge: "Return Calculator",
  calc_title: "Calculate your future pension",
  calc_promo: "From <1>€3,000</1> — already <2>103%</2> per month!",
  calc_promo_pre: "From",
  calc_promo_mid: "— already",
  calc_promo_post: "per month!",
  calc_amount_label: "Contract Amount",
  calc_tier1_label: "3–5%",
  calc_tier1_sub: "up to €3,000",
  calc_tier2_label: "103% 🔥",
  calc_tier2_sub: "from €3,000",
  calc_tier3_label: "157%",
  calc_tier3_sub: "from €5,000",
  calc_tier4_label: "198%",
  calc_tier4_sub: "€10,000",
  calc_return_label: "Return by plan",
  calc_per_year: "per month",
  calc_monthly_label: "Monthly Pension",
  calc_monthly_sub: "per month",
  calc_dividend_label: "Annual Dividend Income",
  calc_dividend_sub: "per year",
  calc_tip: "From <1>€3,000</1> your return is <2>103% per month</2>. At €10,000 — maximum <3>198%</3>.",
  calc_cta: "Sign Investment Contract",

  // Benefits
  benefits_badge: "Why choose us",
  benefits_title: "Advantages of Government Pension Fund Global",
  benefits_desc: "For over 35 years we have provided stable pension and dividend income for thousands of investors worldwide",
  benefits_adv1_title: "State Guarantee",
  benefits_adv1_desc: "Your investments are protected by the state. The fund has operated under the supervision of the Norwegian Ministry of Finance since 1990.",
  benefits_adv2_title: "Stable Growth",
  benefits_adv2_desc: "The fund's average annual return is over 6% over the past 25 years. Your capital works for you.",
  benefits_adv3_title: "Dividend Income",
  benefits_adv3_desc: "Receive monthly dividend payments directly to your account. Transparent reporting and full control.",
  benefits_adv4_title: "Global Diversification",
  benefits_adv4_desc: "The portfolio includes shares of more than 9,000 companies in 70 countries. Maximum risk protection.",
  benefits_adv5_title: "Personal Approach",
  benefits_adv5_desc: "Each client receives a personal manager and an individual investment plan.",
  benefits_adv6_title: "Flexible Terms",
  benefits_adv6_desc: "Choose a contract term from 5 to 30 years. Early exit without penalties.",
  benefits_passive_badge: "Passive Income",
  benefits_passive_title1: "Receive stable",
  benefits_passive_title2: "dividends monthly",
  benefits_passive_desc1: "Dividend income is your passive earnings from investments in the world's largest companies. The fund distributes profits among investors every month, providing a stable cash flow.",
  benefits_passive_desc2: "You can reinvest dividends for accelerated capital growth or receive them in your account — the choice is yours.",
  benefits_li1: "Payments every month without delays",
  benefits_li2: "Profit reinvestment for growth",
  benefits_li3: "Transparent online reporting",
  benefits_li4: "Tax optimization for investors",
  benefits_stat1: "Max monthly payment",
  benefits_stat2: "Maximum return",
  benefits_stat3: "Payments per year",
  benefits_stat4: "State guarantee",
  benefits_reviews_title: "Our clients' stories",
  benefits_reviews_sub: "Real reviews from Government Pension Fund Global investors",
  benefits_t1_text: "\"I invested €10,000 three years ago and now receive a stable €4,200 every month. It changed my life!\"",
  benefits_t1_name: "Anna Müller",
  benefits_t1_meta: "67 · Berlin · Premium",
  benefits_t2_text: "\"Government Pension Fund Global means reliability and stability. My dividend income grows every year.\"",
  benefits_t2_name: "Klaus Berg",
  benefits_t2_meta: "71 · Oslo · Optimal",
  benefits_t3_text: "\"Started with the starter plan, switched to premium after a year. Now I travel the world on my pension payments.\"",
  benefits_t3_name: "Maria Hansen",
  benefits_t3_meta: "64 · Copenhagen · Premium",

  // Contact
  contact_badge: "Contact Us",
  contact_title1: "Start receiving",
  contact_title2: "pension income today",
  contact_desc: "Leave a request and our personal manager will contact you within 24 hours. We will help you choose the optimal investment contract and answer all questions.",
  contact_phone_label: "Phone",
  contact_email_label: "Email",
  contact_address_label: "Address",
  contact_hours_label: "Working Hours",
  contact_hours_val: "Mon–Fri: 09:00–18:00 (CET)",
  contact_form_title: "Leave a Request",
  contact_fname: "First Name",
  contact_fname_ph: "Your first name",
  contact_lname: "Last Name",
  contact_lname_ph: "Your last name",
  contact_email: "Email",
  contact_phone: "Phone",
  contact_plan: "Plan of Interest",
  contact_plan_ph: "Select a plan",
  contact_plan1: "Starter — €3,000 (3–5%)",
  contact_plan2: "Optimal — €5,000 (103%)",
  contact_plan3: "Premium — €10,000 (157–198%)",
  contact_msg: "Message",
  contact_msg_ph: "Your questions or wishes...",
  contact_submit: "Send Request",
  contact_submitting: "Sending...",
  contact_success_title: "Request Sent!",
  contact_success_desc: "Our manager will contact you within 24 hours.",
  contact_privacy: "By clicking the button, you agree to the privacy policy",

  // Footer
  footer_cta_title: "Ready to start investing?",
  footer_cta_desc: "Open an investment contract today and start receiving pension income",
  footer_cta_btn: "Open Account",
  footer_about_desc: "The world's largest sovereign pension fund. Reliable investments with state guarantee.",
  footer_col1: "About the Fund",
  footer_col1_l1: "Fund History",
  footer_col1_l2: "Management Team",
  footer_col1_l3: "Annual Reports",
  footer_col1_l4: "Press Center",
  footer_col2: "Investments",
  footer_col2_l1: "Pension Plans",
  footer_col2_l2: "Return Calculator",
  footer_col2_l3: "Dividend Income",
  footer_col2_l4: "Fund Portfolio",
  footer_col3: "Support",
  footer_col3_l1: "FAQ",
  footer_col3_l2: "Personal Account",
  footer_col3_l3: "Contact Us",
  footer_col3_l4: "Documents",
  footer_col4: "Legal",
  footer_col4_l1: "Privacy Policy",
  footer_col4_l2: "Terms of Use",
  footer_col4_l3: "Licenses",
  footer_col4_l4: "Disclosure",
  footer_copy: "© 2026 Government Pension Fund Global. All rights reserved.",
  footer_disclaimer: "Investments involve risks. Past performance does not guarantee future returns. The fund is supervised by the Norwegian Ministry of Finance.",

  // Live notification
  notif_received: "received",
  notif_plan: "Premium",

  // Plans tiers in calculator
  calc_plan_starter: "Starter",
  calc_plan_optimal: "Optimal",
  calc_plan_advanced: "Advanced",
  calc_plan_premium: "Premium",
};

export default translations;
